import React from 'react';
import { View, Pressable, StyleSheet, Image } from 'react-native';
import { COLOR, FONT, FONT_SIZE, THEME } from '../../../../constants/styles';

import OPComponent from '../../op_component';

export default class RemoveButton extends OPComponent {
  constructor(props) {
    super(props);
  }

  handlePress = () => {
    this.props.onPress && this.props.onPress(this.props.item);
  };

  render() {
    const { width } = this.props;
    return (
      <Pressable onPress={this.handlePress} style={styles.removeButton}>
        <View style={[styles.removeButtonInner, { width }]}>
          <Image style={styles.icon} source={require('../../../../../resources/icon-reject.png')} />
        </View>
      </Pressable>
    );
  }
}

const styles = StyleSheet.create({
  removeButton: THEME.removeButton,
  removeButtonInner: {
    ...THEME.removeButtonInner,
  },
  icon: {
    width: 30,
    height: 30,
    tintColor: 'white',
  },
});
